<template>
  <v-main>
    <ORow fill-y fill-x>
      <OLoadingDialog :value="isLoading" />
      <PreviewDialog ref="previewDialog" />

      <OSelectSingleDialog
        ref="selectOrgDialog"
        title="Selecionar Organização..."
        :items="allOrgs"
        labelProp="label"
      />

      <div v-if="isLoading && row == null" class="jumbo">
        <v-icon>refresh</v-icon>
        Carregando...
      </div>

      <div v-if="!isLoading && row == null" class="jumbo">
        <v-icon>error_outline</v-icon>
        ScreenSet não encontrado.
      </div>

      <ORow v-if="row != null" fill-y>
        <ScreenSetSidebar
          v-model="row"
          @reload="reload"
          @update="save"
          @preview="doPreview"
          @embed="doEmbed"
          @createChecklist="doCreateChecklist"
        />

        <div class="fill-height">
          <TransitionGroup
            name="s-list"
            tag="div"
            class="screens-list pa-2 children-ma-2 scroll-y"
          >
            <!-- <div v-for="(screen, index) in allScreens"
          :key="index">
            {{index}}
          </div> -->

            <Screen
              v-for="(screen, index) in row.screens"
              :value="screen"
              :index="index"
              :key="index"
              :allScreens="row.screens"
              @update="(v) => updateScreen(screen, v)"
              @remove="removeScreen(screen)"
              @duplicate="duplicateScreen(screen)"
              @move="(v) => moveScreen(screen, index, v.newIndex)"
              @preview="doPreview"
            />

            <div class="elevation-0 new-screen-placeholder" key="newScreenBtn">
              <v-btn icon x-large @click="addScreen">
                <v-icon>mdi-tooltip-plus-outline</v-icon>
              </v-btn>
              <v-btn text x-large @click="addScreen">Nova Tela</v-btn>
            </div>

            <v-spacer key="theSpacer" />
          </TransitionGroup>
        </div>
      </ORow>
    </ORow>
  </v-main>
</template>

<script>
import { ScreenSet, Org } from '@/models'
import { hasTag } from 'oderon-commons/src/utils'

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ScreenSetSidebar: require('./ScreenSetSidebar.vue').default,
    Screen: require('./Screen').default,
    PreviewDialog: require('./PreviewDialog.vue').default,
    OSelectSingleDialog: require('oderon-vue/cpts/OSelectSingleDialog.vue')
      .default
  },
  props: {
    id: {}
  },
  data() {
    return {
      isLoading: false,
      row: null,
      allOrgs: []
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.row = await ScreenSet.findById(this.id)
      let allOrgs = await Org.findAll({ mini: true })
      this.allOrgs = allOrgs.filter((x) => hasTag(x.extraInfo, 'Checklist'))
    },

    addScreen() {
      this.row.screens.push({
        line0: null,
        line1: null,
        isDynamic: false,
        isOneLiner: false,
        buttons: {},
        func: '0x00',
        backlight: '0x00'
      })

      this.save()
    },

    removeScreen(screen) {
      let i = this.row.screens.indexOf(screen)
      this.row.screens.splice(i, 1)
      this.save()
    },

    duplicateScreen(screen) {
      let dup = JSON.parse(JSON.stringify(screen))
      this.row.screens.push(dup)
      this.save()
    },

    moveScreen(screen, oldIndex, newIndex) {
      // clamp no item
      if (newIndex < 0) newIndex = 0
      if (newIndex >= this.row.screens.length)
        newIndex = this.row.screens.length - 1

      // Se o índice é igual ao atual, não faz nada.
      if (newIndex == oldIndex) {
        return
      }

      this.row.screens.splice(oldIndex, 1)
      this.row.screens.splice(newIndex, 0, screen)
      this.save()
    },

    updateScreen(screen, data) {
      Object.assign(screen, data)
      this.save()
    },

    async save() {
      await ScreenSet.save(this.row)
    },

    async doPreview({ type, obj }) {
      await this.$refs.previewDialog.open(type, obj)
    },

    async doEmbed() {},

    async doCreateChecklist() {
      let res = await this.$refs.selectOrgDialog.open()
      if (res != null) {
        this.$loading(async () => {
          await ScreenSet.sync({
            screenSetId: this.row.id,
            orgCode: res.name
          })
          this.$snack('Checklist criado com sucesso')
        })
      }
    }
  }
}
</script>

<style lang="sass">
.new-item-border
  border: 5px solid #eee

.screens-list
  display: flex
  flex-flow: row
  flex-wrap: wrap
  align-items: flex-start
  justify-content: flex-start
  height: 100%
  overflow-y: auto

.new-screen-placeholder
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  height: 256px
  width: 256px

/* apply transition to moving elements */
.s-list-move,
.s-list-enter-active,
.s-list-leave-active
  transition: all 0.5s ease

.s-list-enter-from,
.s-list-leave-to
  opacity: 0
  transform: translateX(30px)

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.s-list-leave-active
  // position: absolute
</style>
